// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { BulkItemInventoryItem, InventoryEntry } from '@/inventory/api/types';
import { SparseItem } from '@/sparse/api/types';

/**
 * Builds a map of locationId -> itemId -> count, keyed by each exact location the rows list
 */
export function buildLocationInventoryMap(
  rows: { item: SparseItem; inventory: InventoryEntry[] }[]
): Map<string, Map<string, number>> {
  const inventoryMap = new Map<string, Map<string, number>>();
  for (const row of rows) {
    for (const entry of row.inventory) {
      const locationMap =
        inventoryMap.get(entry.location.id) ?? new Map<string, number>();
      locationMap.set(
        row.item.id,
        (locationMap.get(row.item.id) ?? 0) + entry.count
      );
      inventoryMap.set(entry.location.id, locationMap);
    }
  }

  return inventoryMap;
}

/**
 * Drops each location's shortage from bulk item rows, so a location below zero offers nothing
 */
export function toStockedBulkItems(
  rows: BulkItemInventoryItem[]
): BulkItemInventoryItem[] {
  return rows.map((row) => ({
    ...row,
    inventory: row.inventory.filter((entry) => entry.count > 0),
  }));
}
